export enum InternationaProviderOnboardingStatusTypes {
  initiated = 'initiated',
  completedDetailsForm = 'completedDetailsForm',
  completedCredentialsForm = 'completedCredentialsForm',
  completedIDVerificationForm = 'completedIDVerificationForm',
  completedSelfieVerificationForm = 'completedSelfieVerificationForm',
  completedTechnologyPlatformAgreement = 'completedTechnologyPlatformAgreement',
  completedOnboarding = 'completedOnboarding',
}
